import { render, staticRenderFns } from "./PDFPageMobile.vue?vue&type=template&id=6a349991&lang=pug"
import script from "./PDFPageMobile.vue?vue&type=script&lang=js"
export * from "./PDFPageMobile.vue?vue&type=script&lang=js"
import style0 from "./PDFPageMobile.vue?vue&type=style&index=0&id=6a349991&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports